import {
  CreatePolicyJobPayload,
  LabelingStatus,
  UpdatePolicyPayload,
} from './labeledDataClient.types';
import { PolicyClient } from '../policies/policyClient';
import { ResourceType } from '../policies/policyClient.types';

export class LabeledDataClient extends PolicyClient {
  async createLabeledPolicyJob(data: CreatePolicyJobPayload) {
    const input = {
      TableName: this.tableName,
      Item: {
        resourceType: ResourceType.Policy,
        resourceId: data.policyId,
        policyUUID: data.policyUUID,
        carrierName: data.carrierName,
        policyType: data.policyType,
        labelingStatus: LabelingStatus.Pending,
      },
      ConditionExpression:
        'attribute_not_exists(resourceType) AND attribute_not_exists(resourceId)',
    };
    try {
      await this.putItem(input);
    } catch (e: any) {
      if (e.__type.includes('ConditionalCheckFailedException')) {
        throw new Error('Record already exists');
      } else {
        throw e;
      }
    }
  }

  async deleteLabeledPolicyJob(policyId: string) {
    const vehicles = await this.getVehicles({ policyId });
    const drivers = await this.getDrivers({ policyId });
    await Promise.all(
      [...vehicles, ...drivers].map((resource) => {
        const resourceInput = {
          TableName: this.tableName,
          Key: {
            resourceType: resource.resourceType,
            resourceId: resource.resourceId,
          },
        };
        return this.deleteItem(resourceInput);
      }),
    );

    const policyInput = {
      TableName: this.tableName,
      Key: {
        resourceType: ResourceType.Policy,
        resourceId: policyId,
      },
    };

    await this.deleteItem(policyInput);
  }

  async updatePolicyDetails(
    originalPolicyId: string,
    data: UpdatePolicyPayload,
  ) {
    const input: any = {
      TableName: this.tableName,
      Key: {
        resourceType: ResourceType.Policy,
        resourceId: originalPolicyId,
      },
      UpdateExpression: 'SET ',
      ExpressionAttributeValues: {},
      ReturnValues: 'ALL_NEW',
    };

    Object.entries(data).forEach(([label, value], i) => {
      if (value) {
        input.UpdateExpression += ` ${label}=:value${i},`;
        input.ExpressionAttributeValues[`:value${i}`] = value;
      }
    });

    input.UpdateExpression = input.UpdateExpression.slice(0, -1);

    const policy = await this.updateItem(input);
    if (!policy) throw new Error('No returned attributes');
    return policy;
  }
}
